module.exports = __webpack_public_path__ + "img/down-neimeng2.73b95701.jpg";